window.addEventListener('load', () => {
    lozad('.lozad', {
        loaded: function (el) {
            el.classList.add('fade')
        }
    })
    .observe();

});
